export default __webpack_public_path__ + "static/media/Free.37256f8f.jpeg";